module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"links":"Useful links"},"fr":{"links":"Liens utiles"}}')
  delete Component.options._Ctor
}
